const ONE_MINUTE_MS = 60_000;

/**
 * Firestore の SNS インサイトを画面へ反映するための共通キャッシュ設定。
 *
 * - 1 分以内の画面復帰は再取得を抑え、短時間のタブ移動による read 増加を避ける
 * - 非表示になってから 5 分でキャッシュを破棄し、分析データを無期限に保持しない
 * - 表示中は 10 分間隔で再取得し、バックグラウンドではポーリングしない
 */
export const SNS_INSIGHTS_QUERY_OPTIONS = {
  staleTime: ONE_MINUTE_MS,
  cacheTime: 5 * ONE_MINUTE_MS,
  refetchOnWindowFocus: true,
  refetchInterval: 10 * ONE_MINUTE_MS,
  refetchIntervalInBackground: false,
} as const;
